// Hands on project descriptions
function showPopup(title, description) {
  const popup = document.getElementById("popup");
  document.getElementById("popup-title").innerText = title;
  document.getElementById("popup-description").innerText = description;
  popup.classList.remove("hidden");
}

function closePopup() {
  const popup = document.getElementById("popup");
  popup.classList.add("hidden");
}

function closePopupOnOutside(event) {
  if (event.target.id === "popup") {
    document
      .querySelector(".popup-content")
      .addEventListener("click", (e) => e.stopPropagation());
    closePopup();
  }
}

let popupButtons = document.querySelectorAll(".plus-icon");
popupButtons.forEach((button) => {
  button.addEventListener("click", () => {
    let title = button.getAttribute("data-title");
    let description = button.getAttribute("data-description");
    showPopup(title, description);
  });
});

document.querySelector(".popup .close").addEventListener("click", closePopup);
document.getElementById("popup").addEventListener("click", closePopupOnOutside);
